import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import Toast from '../Util/Toast/Toast';
import { loadData } from '../Util/List/CustomList/loadData';
import { useDispatch } from 'react-redux';
import Fetch from '../../../util/core/Fetch';
import { getUserSession } from '../../../util/core/Session';

function List() {

  const dispatch = useDispatch()

  setInterval(() => {
    dispatch({ type: 'UPDATE_SESSION', key: 'current_tab_filter_notifications', value: [5, 6] });
  }, 1000)

  const pathFrontEnd = '/core/examples/crud/backend/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointDelete: `${config.endpoints.backend}core/crudexample/delete`,
    endpointClone: `${config.endpoints.backend}core/crudexample/clone`,
    endpointSave: `${config.endpoints.backend}core/crudexample/save`,
    endpointSaveSelect: `${config.endpoints.backend}core/crudexample/saveGenderSelect`,
    endpoint: config.endpoints.backend + 'core/crudexample/getall'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'cnpj',
        type: 'CNPJ',
        label: 'CNPJ',
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'gender',
        type: 'select',
        label: 'Gênero',
        isClearable: true,
        options: [
          { label: 'Masculino', value: 'M' },
          { label: 'Feminino', value: 'F' }
        ],
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ],
  }

  const session = getUserSession();
  const genderOptions = [{label: 'Masculino', value: 'M'}, {label: 'Feminino', value: 'F'}];

  let list = {
    labelTitle: 'Lista de empresas (CRUD backend exemplo)',
    labelTitleButtonAdd: 'Incluir nova empresa',
    viewActionColumn: true,
    fieldsShowOnDelete: ['company_name'],
    cloneButton: {
      fieldsToShowOnClone: ['company_name'],
      columnForCloneName: 'company_name',
      showCloneButton: true
    },
    buttonsListContainer: [
      {
        name: 'customized_button',
        class: 'btn btn-primary',
        label: 'Botão customizado',
        tooltipLabel: 'Botão customizado',
        icon: 'fa fa-plus', //can null
        callback: () => {
          console.log('Customizado')
        }
      }
    ],
    showPrintButtons: true,
    canDownload: true,
    saveState: true,
    formFilters: filters,
    saveState: true,
    tabFilters: [
      {
        label: 'Masculino',
        notificationsNumber: 2,
        filters: {
          gender: 'M'
        }
      },
      {
        label: 'Feminino',
        notificationsNumber: 2,
        filters: {
          gender: 'F'
        }
      },
    ],
    fieldToDownload: 'file',
    columns: [
      {
        name: 'cnpj',
        label: 'CNPJ',
        tooltip: {
          title: 'CNPJ',
          description: 'Este é um campo que informa o CNPJ',
          column: false,
          columnValue: true
        }
      },  
      {
        width: '20%',
        name: 'company_name',
        label: 'Empresa',
        editable: true,
        endpointSave: paths.endpointSave,
        maxLength: "50",
      },
      {
        name: 'gender',
        label: 'Gênero',
        options: genderOptions,
        editable: true,
        type: "select",
        endpointSave: paths.endpointSave,
        width: '12%',
        minWidth: '120px'
      },
    ],
    columnsButtons: [
      {
        buttons: [
          {
            width: '8%',
            label: 'Disparar',
            icon: 'fas fa-users',
            onClick: item => {
              Toast.success(item.company_name);
            }
          },
          {
            width: '8%',
            label: 'Ativo',
            type: 'switch',
            onChange: async (element, item) => {
              try {
                item.switch_value = element.target.checked ? '1' : '0';
                const url = config.endpoints.backend + 'core/crudexample/save'
                await Fetch.put(url, item);
                if (element.target.checked) {
                  Toast.success('Ativado com sucesso');
                } else {
                  Toast.error('Item desativado');
                }
              } catch (e) {
                Toast.error(e);
              }
            },
            fieldValue: 'switch_value'
          },
          {
            width: '8%',
            label: 'Ativo Desativado',
            type: 'switch',
            onChange: async (element, item) => {
              return
            },
            fieldValue: 'switch_value',
            disabled: true
          },
          {
            width: '8%',
            label: 'Botão CNPJ',
            hideCustomButton: (row) => row.gender !== "M",
            onClick: item => {
              Toast.success(item.cnpj);
            }
          },
          {
            width: '8%',
            label: 'Dropdown Ações',
            labelButton: 'Título',
            icon: 'fas fa-angle-right',
            buttonClass: 'btn btn-primary',
            showActionButtons: false,
            showCloneButton: true,
            type: 'listButton',
            buttons: [
              {
                label: 'Botão Exemplo',
                icon: 'fas fa-angle-right mr-2',
                hideListButtonRule: (row, item) => item.gender === "M",
                onClick: item => {
                  Toast.success("Este é um exemplo");
                }
              },
            ]
          },
        ]
      }
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
      />
    </div>
  );
}
export default List;